import { useState, useEffect } from "react";
import {
  Typography,
  Box,
  IconButton,
  InputBase,
  Dialog,
  DialogContent,
  Button,
  TextField,
  Autocomplete,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseProductManagment } from "./UseProductManagment";
import { useLocation } from "react-router-dom";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import {
  deCapitalizeFirstLetter,
  removeComma,
  toMoney,
} from "../../util/Utils";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import EditIcon from "@mui/icons-material/Edit";

export default function ProductManagment() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getProductStoreList, updateProductStore } = UseProductManagment();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("FaName");
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [openD, setOpenD] = useState({ show: false, model: undefined });
  const [productRes, setProductRes] = useState();
  const [state, setState] = useState({
    id: undefined,
    cost: null,
    maxSell: null,
    stoke: null,
  });

  const DeliveryCost = [
    {
      id: 1,
      value: "دارد",
    },
    {
      id: 2,
      value: "ندارد",
    },
    {
      id: 3,
      value: "براساس سفارش",
    },
  ];

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getProductStoreList(
      myPc,
      search,
      (products) => {
        if (msGotoLast) {
          setMsGotoLast(false);
          goToLastPage(products.pageCondition.totalPage);
          return;
        }
        setProductRes(products);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
    },

    {
      field: "faName",
      headerName: "نام محصول",
      width: 200,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="span" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.faName}
          </Typography>
        );
      },
    },
    {
      field: "cost",
      headerName: "قیمت",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="span"
              sx={{
                width: "100%",
                textAlign: "center",
                whiteSpace: "normal",
              }}
            >
              {cellValues.row.cost ? toMoney(cellValues.row.cost) : 0}
            </Typography>
            <IconButton
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              onClick={() => {
                setState({
                  // ...state,
                  id: cellValues.row.id,
                  cost: cellValues.row.cost,
                });
                setOpenD({
                  Coll: "cost",
                  show: true,
                  model: cellValues.row,
                });
              }}
            >
              <EditIcon fontSize="small" color="secondary" />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "discountCost",
      headerName: "قیمت با تخفیف",
      width: 130,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="span"
              sx={{
                width: "100%",
                textAlign: "center",
                whiteSpace: "normal",
              }}
            >
              {cellValues.row.discountCost
                ? toMoney(cellValues.row.discountCost)
                : 0}
            </Typography>
            <IconButton
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              onClick={() => {
                setState({
                  // ...state,
                  id: cellValues.row.id,
                  discountCost: cellValues.row.discountCost,
                });
                setOpenD({
                  Coll: "discountCost",
                  show: true,
                  model: cellValues.row,
                });
              }}
            >
              <EditIcon fontSize="small" color="secondary" />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "stoke",
      width: 110,
      align: "center",
      headerName: "موجودی",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="span"
              sx={{
                width: "100%",
                textAlign: "center",
                whiteSpace: "normal",
              }}
            >
              {cellValues.row.stoke ? toMoney(cellValues.row.stoke) : 0}
            </Typography>
            <IconButton
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              onClick={() => {
                setState({
                  // ...state,
                  id: cellValues.row.id,
                  stoke: cellValues.row.stoke,
                });
                setOpenD({
                  Coll: "stoke",
                  show: true,
                  model: cellValues.row,
                });
              }}
            >
              <EditIcon fontSize="small" color="secondary" />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "maxSell",
      width: 110,
      align: "center",
      headerName: "سقف فروش",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="span"
              sx={{
                width: "100%",
                textAlign: "center",
                whiteSpace: "normal",
              }}
            >
              {cellValues.row.maxSell ? toMoney(cellValues.row.maxSell) : 0}
            </Typography>
            <IconButton
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              onClick={() => {
                setState({
                  // ...state,
                  id: cellValues.row.id,
                  maxSell: cellValues.row.maxSell,
                });
                setOpenD({
                  Coll: "maxSell",
                  show: true,
                  model: cellValues.row,
                });
              }}
            >
              <EditIcon fontSize="small" color="secondary" />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "hasDeliveryCost",
      width: 130,
      align: "center",
      headerName: "هزینه ارسال",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              justifyContent: "center",
            }}
          >
            {cellValues.row.hasDeliveryCost == 1 && (
              <Typography variant="span">دارد</Typography>
            )}
            {cellValues.row.hasDeliveryCost == 2 && (
              <Typography variant="span">ندارد</Typography>
            )}
            {cellValues.row.hasDeliveryCost == 3 && (
              <Typography variant="span">براساس سفارش</Typography>
            )}
            <IconButton
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              onClick={() => {
                setState({
                  // ...state,
                  id: cellValues.row.id,
                  hasDeliveryCost: cellValues.row.hasDeliveryCost,
                });
                setOpenD({
                  Coll: "deliverCost",
                  show: true,
                  model: cellValues.row,
                });
              }}
            >
              <EditIcon fontSize="small" color="secondary" />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              fullWidth
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];
  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [{ name: msActiveMenu.pageTitle, url: "/productstorage" }],
      }}
    >
      <Dialog
        PaperProps={{
          elevation: 1,
        }}
        fullWidth
        maxWidth="xs"
        open={openD.show}
        onClose={() => setOpenD({ ...openD, show: false })}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {openD.Coll == "cost" && (
              <TextField
                autoFocus={true}
                size="small"
                id="outlined-basic"
                value={state && state.cost ? toMoney(state.cost) : ""}
                label="قیمت"
                variant="outlined"
                onChange={(event) => {
                  setState({
                    ...state,
                    cost: removeComma(event.target.value),
                  });
                }}
                sx={{ width: "100%", input: { direction: "rtl" } }}
              />
            )}
            {openD.Coll == "stoke" && (
              <TextField
                autoFocus={true}
                size="small"
                id="outlined-basic"
                value={state && state.stoke ? toMoney(state.stoke) : ""}
                label="موجودی"
                variant="outlined"
                onChange={(event) => {
                  setState({
                    ...state,
                    stoke: removeComma(event.target.value),
                  });
                }}
                sx={{ width: "100%", input: { direction: "rtl" } }}
              />
            )}
            {openD.Coll == "discountCost" && (
              <TextField
                autoFocus={true}
                size="small"
                id="outlined-basic"
                value={
                  state && state.discountCost ? toMoney(state.discountCost) : ""
                }
                label="قیمت با تخفیف"
                variant="outlined"
                onChange={(event) => {
                  setState({
                    ...state,
                    discountCost: removeComma(event.target.value),
                  });
                }}
                sx={{ width: "100%", input: { direction: "rtl" } }}
              />
            )}
            {openD.Coll == "maxSell" && (
              <TextField
                autoFocus={true}
                size="small"
                id="outlined-basic"
                value={state && state.maxSell ? toMoney(state.maxSell) : 0}
                label="سقف فروش"
                variant="outlined"
                onChange={(event) => {
                  setState({
                    ...state,
                    maxSell: removeComma(event.target.value),
                  });
                }}
                sx={{ width: "100%", input: { direction: "rtl" } }}
              />
            )}
            {openD.Coll == "deliverCost" && (
              <Autocomplete
                size="small"
                value={
                  state && state.hasDeliveryCost ? state.hasDeliveryCost : ""
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setState({ ...state, hasDeliveryCost: newValue });
                  } else {
                    setState({ ...state, hasDeliveryCost: undefined });
                  }
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return DeliveryCost?.find((m) => m.id == option).value;
                  }
                  return "";
                }}
                fullWidth
                options={DeliveryCost.map((m) => m.id)}
                renderInput={(params) => (
                  <TextField
                    sx={{ input: { textAlign: "center" } }}
                    variant="outlined"
                    {...params}
                    label="هزینه ارسال"
                  />
                )}
              />
            )}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mt: 2,
              }}
            >
              <Button
                sx={{ mr: 2 }}
                color="secondary"
                variant="contained"
                onClick={() => {
                  updateProductStore(state, (call) => {
                    refresh();
                    setOpenD({ ...openD, show: false });
                  });
                }}
              >
                ثبت
              </Button>
              <Button
                color="secondary"
                variant="outlined"
                onClick={() => {
                  setOpenD({ ...openD, show: false });
                }}
              >
                انصراف
              </Button>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
      {productRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={productRes.pageCondition.pageCount}
          rows={productRes.product}
          paginationMode="server"
          page={productRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={
            productRes?.pageCondition.totalItemCount
              ? productRes.pageCondition.totalItemCount
              : 1
          }
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              isLtr: true,
              nofab: true,
              rowCount: productRes?.pageCondition.totalItemCount
                ? productRes.pageCondition.totalItemCount
                : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
